class FixedArea {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const navItems = $(".js-fixed-area-item");

    const sections = [];
    navItems.each(function () {
      const target = $($(this).attr("href"));
      if (target.length) {
        sections.push(target);
      }
    });

    $(window).on("scroll", function () {
      const scrollPos = $(window).scrollTop() + $(window).height() / 2;
      // const offset = 150;

      let currentId = "";

      sections.forEach(section => {
        const top = section.offset().top;
        const bottom = top + section.outerHeight();    

        if (scrollPos >= top && scrollPos < bottom) {
          currentId = section.attr("id");
        }
      });

      navItems.each(function () {
        const href = $(this).attr("href").replace("#", "");

        if (href === currentId) {
          $(this).addClass("is-active");
        } else {
          $(this).removeClass("is-active");
        }
      });

    });
  }
}
